import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconAlignmentLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"alignment-left"} maskId="square-filled-radius-0-stroke-1-IconAlignmentLeft"><path fillRule="evenodd" clipRule="evenodd" d="M3 4H21V5H3V4ZM3 4H21V5H3V4ZM3 4H21V5H3V4Z" fill="currentColor"/><path d="M13 11.5V12.5H3V11.5H13Z" fill="currentColor"/><path d="M21 19V20H3V19H21Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconAlignmentLeft;
